import { Component } from '@angular/core';

@Component({
  selector: 'app-bart',
  templateUrl: './bart.component.html',
  styleUrls: ['./bart.component.scss'],
  standalone: true,
})
export class BartComponent {}
